// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"135":"8546c1be","435":"1a97bff0","596":"52d4c899","699":"41a4ddfb"}[chunkId] + ".chunk.js";
};